import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OrderByModule } from '@lib/util';
import { MatIconButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { FrameworkAgreement } from '../SupplierFrameworkAgreement';

export class SupplierFrameworkAgreementDialogData {
    constructor(
        public readonly supplierCompanyId: string,
        public readonly editable = false,
        public readonly options: FrameworkAgreement[],
    ) {}
}

@Component({
    selector: 'supplier-framework-agreement-selection-dialog',
    imports: [MatIconButton, OrderByModule, TranslateModule],
    templateUrl: './demand-supplier-framework-agreement-dialog.html',
})
export class SupplierFrameworkAgreementDialogComponent {
    private readonly dialogRef = inject<MatDialogRef<SupplierFrameworkAgreementDialogComponent>>(MatDialogRef);
    data = inject<SupplierFrameworkAgreementDialogData>(MAT_DIALOG_DATA);

    public cancel(): void {
        this.dialogRef.close();
    }

    public save(supplierFrameworkAgreement: FrameworkAgreement): void {
        this.dialogRef.close(supplierFrameworkAgreement);
    }
}
